import { abi } from './abi';
class Staking {
}
Staking.abi = abi;
Staking.address = '0xe6D97B2099F142513be7A2a068bE040656Ae4591';
export { Staking };
//# sourceMappingURL=staking.js.map